import { Routes } from '@angular/router';

export const adminRoutes: Routes = [
  {
    path: 'admin',
    canActivate: [() => import('../../core/guards/admin.guard').then(m => m.adminGuard)],
    loadComponent: () => import('./layout/layout.component').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'farmacias',
        loadComponent: () => import('./farmacias/farmacias.component').then(m => m.FarmaciasComponent)
      },
      {
        path: 'farmacias/:id',
        loadComponent: () => import('./farmacia-detalhes/farmacia-detalhes.component').then(m => m.FarmaciaDetalhesComponent)
      },
      {
        path: 'pacientes',
        loadComponent: () => import('./pacientes/pacientes.component').then(m => m.PacientesComponent)
      },
      {
        path: 'pacientes/:id',
        loadComponent: () => import('./paciente-detalhes').then(m => m.PacienteDetalhesComponent)
      },
      // Redirect old routes for backwards compatibility
      {
        path: 'clientes',
        redirectTo: 'pacientes',
        pathMatch: 'full'
      },
      {
        path: 'clientes/:id',
        redirectTo: 'pacientes/:id',
        pathMatch: 'full'
      },
      {
        path: 'pedidos',
        loadComponent: () => import('./pedidos/pedidos.component').then(m => m.PedidosComponent)
      },
      {
        path: 'planos',
        loadComponent: () => import('./planos/planos.component').then(m => m.PlanosComponent)
      },
      {
        path: 'assinaturas',
        loadComponent: () => import('./assinaturas/assinaturas.component').then(m => m.AssinaturasComponent)
      },
      {
        path: 'logs',
        loadComponent: () => import('./logs/logs.component').then(m => m.LogsComponent)
      },
      {
        path: 'suporte',
        loadComponent: () => import('./suporte/suporte.component').then(m => m.AdminSuporteComponent)
      },
      {
        path: 'suporte/ticket/:id',
        loadComponent: () => import('./suporte/ticket-detalhes/ticket-detalhes.component').then(m => m.AdminTicketDetalhesComponent)
      },
      {
        path: 'notificacoes',
        loadComponent: () => import('./notificacoes/notificacoes.component').then(m => m.AdminNotificacoesComponent)
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./relatorios/relatorios.component').then(m => m.AdminRelatoriosComponent)
      },
      {
        path: 'estatisticas',
        loadComponent: () => import('./estatisticas/estatisticas.component').then(m => m.EstatisticasComponent)
      },
      {
        path: 'configuracoes',
        loadComponent: () => import('./configuracoes/configuracoes.component').then(m => m.AdminConfiguracoesComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }
];
